/** @file AskAgentField: a text box whose Ask button hands its text to the agent (Agent screen). */
import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';

/** The text to start from (the selected slot's prompt) and what asking does. */
export type AskAgentFieldProps = { suggestion: string; onAsk: (text: string) => void };

/** A textarea prefilled with `suggestion` (refilled when it changes) and an Ask the agent button. */
export function AskAgentField({ suggestion, onAsk }: AskAgentFieldProps): ReactElement {
  const [text, setText] = useState(suggestion);
  useEffect(() => { setText(suggestion); }, [suggestion]);
  return (
    <section aria-label="Ask the agent" style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 11 }}>
      <h4 style={{ margin: '4px 0', fontSize: 12 }}>Ask the agent</h4>
      <textarea value={text} rows={4} onChange={(e) => { setText(e.target.value); }} style={{ resize: 'vertical', fontSize: 11 }} />
      <button type="button" disabled={text.trim() === ''} onClick={() => { onAsk(text.trim()); }}>Ask the agent</button>
    </section>
  );
}
